import React from "react";
import { IStandardId } from "../../Stream.props";
import EditStream from "./EditStream";

const EditStreamIndex: React.FC<IStandardId> = ({ standardId }) => {
  return <EditStream standardId={standardId} />;
};

export default EditStreamIndex;
